import InputText from '@/trio-ui/InputText';
import { Grid, InputWrapper } from './PersonalInfoContactForm.styles';

type Props = {
  email: string;
  workEmail: string;
  mobilePhone: string;
  linkedinUrl: string;
  isMyPersonalInfo?: boolean;
  onChange: (name: string, value: any) => void;
};

const PersonalInfoContactForm = ({
  email,
  workEmail,
  mobilePhone,
  linkedinUrl,
  onChange,
  isMyPersonalInfo = false,
}: Props): JSX.Element => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    onChange(e.target.name, e.target.value);
  };

  return (
    <Grid>
      <InputWrapper>
        <InputText label="Personal Email" name="email" value={email} onChange={handleChange} />
      </InputWrapper>
      <InputWrapper>
        <InputText label="Phone" name="mobilePhone" value={mobilePhone} onChange={handleChange} />
      </InputWrapper>
      <InputWrapper>
        <InputText
          label="Work Email"
          name="workEmail"
          value={workEmail}
          onChange={handleChange}
          readonly={isMyPersonalInfo}
        />
      </InputWrapper>
      <InputWrapper>
        <InputText
          label="LinkedIn Link"
          name="linkedinUrl"
          value={linkedinUrl}
          onChange={handleChange}
        />
      </InputWrapper>
    </Grid>
  );
};

export default PersonalInfoContactForm;
